import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const SubscriptionStatusInput = ({name, label, fieldKey=null, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 0,
      label: "accounts_input_subscription_status_none",
    },
    {
      value: 1,
      label: "accounts_input_subscription_status_active",
    },
    {
      value: 2,
      label: "accounts_input_subscription_status_pending",
    },
    {
      value: 3,
      label: "accounts_input_subscription_status_canceled",
    },
    {
      value: 4,
      label: "accounts_input_subscription_status_failed",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name || 'subscription_status'}
          fieldKey={fieldKey}
          label={label || t('accounts_input_subscription_status')}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default SubscriptionStatusInput;
